import angular from 'angular';
import moment from 'moment';
import gridHeight from '../core/shared-service/grid-utils';

class editInvitedEntityCtrl {
    /* @ngInject */
    constructor(
        $state,
        $uibModal,
        $translate,
        $window,
        KISS_USER,
        uiGridExporterConstants,
        KissSellerSvc,
        KissUserSvc,
        PrincipalSvc,
        AuthSvc,
        CONF,
        logger,
        UserBo,
        invitedEntitySvc,
        linkRequestSvc,
        LINK_REQUEST
    ) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.$window = $window;
        this.KISS_USER = KISS_USER;
        this.uiGridExporterConstants = uiGridExporterConstants;
        this.KissSellerSvc = KissSellerSvc;
        this.KissUserSvc = KissUserSvc;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
        this.CONF = CONF;
        this.logger = logger;
        this.UserBo = UserBo;
        this.invitedEntitySvc = invitedEntitySvc;
        this.linkRequestSvc = linkRequestSvc;
        this.LINK_REQUEST = LINK_REQUEST;
    }

    $onInit() {
        const usersDefaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.kissuser.edit({legalEntityId: grid.appScope.$ctrl.invitedEntity.legalEntity.id, principalId: grid.appScope.$ctrl.principalEntity.id, id:row.entity.login, previousState:{name:grid.appScope.$ctrl.currentStateName, params:grid.appScope.$ctrl.stateParams}})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        // ---------------
        // Data API
        // ---------------
        this.invitedEntity = this.invitedEntityBo.invitedEntity;
        this.linkRequestSvc.getLinkRequestCount(this.invitedEntity.legalEntity.id, this.LINK_REQUEST.TYPE.client).then(data => this.invitedBuyerLinkRequestCount = data);
        if (this.invitedEntity.invoiceEmailShared && !this.invitedEntity.sellerRobotKey) {
            var countryCode = this.invitedEntity.legalEntity.countryCode.toUpperCase();
            if (this.invitedEntity.legalEntity.idFiscalKind && this.invitedEntity.legalEntity.idFiscal) {
                this.invitedEntity.sellerRobotKey =
                    countryCode +
                    '_' +
                    this.invitedEntity.legalEntity.idFiscalKind.toUpperCase() +
                    '_' +
                    this.invitedEntity.legalEntity.idFiscal.toUpperCase();
            } else {
                this.invitedEntity.sellerRobotKey =
                    countryCode +
                    '_' +
                    this.invitedEntity.legalEntity.idNationalKind.toUpperCase() +
                    '_' +
                    this.invitedEntity.legalEntity.idNational.toUpperCase();
            }
        }
        this.changeIdFormInfo = this.invitedEntityBo.changeIdFormInfo;
        this.principalEntity = this.invitedEntityBo.principalEntity;
        this.principalInfos = this.invitedEntityBo.principal.items;
        this.invitations = this.invitedEntityBo.invitations.items;
        this.users = this.invitedEntityBo.users.items;
        this.isDocumentarySpaceAuthorized = this.AuthSvc.isAuthorized('CONFIGURATOR');

        // ---------------
        // Function API
        // ---------------

        this.principal = this.PrincipalSvc.getPrincipal();

        this.currentStateName = this.$state.current.name;
        this.stateParams = this.$state.params;

        // Liste des users
        this.usersGridOptions = {
            columnDefs: [
                {
                    name: 'login',
                    displayName: 'kiss_user.list.login',
                    headerCellFilter: 'translate',
                    cellTemplate: usersDefaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'lastname',
                    displayName: 'kiss_user.list.lastname',
                    headerCellFilter: 'translate',
                    cellTemplate: usersDefaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'firstname',
                    displayName: 'kiss_user.list.firstname',
                    headerCellFilter: 'translate',
                    cellTemplate: usersDefaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getRoleLabel()',
                    displayName: 'kiss_user.list.profil',
                    headerCellFilter: 'translate',
                    cellTemplate: usersDefaultCellTemplate,
                    cellClass: 'pointer',
                    width: 110,
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'kiss_user.list.status',
                    headerCellFilter: 'translate',
                    cellTemplate: usersDefaultCellTemplate,
                    cellClass: 'pointer',
                    width: 80,
                },
            ],
            exporterOlderExcelCompatibility: true,
            useExternalPagination: false,
            useExternalSorting: false,
            onRegisterApi: gridApi => (this.userGridApi = gridApi),
            enableSorting: true,
            enableGridMenu: false,
            data: this.invitedEntityBo.users.items,
            totalItems: this.invitedEntityBo.users.totalItems,
        };

        // Liste des donneurs d'ordres du fournisseur.
        const defaultCellTemplate =
            '<div  class="ui-grid-cell-contents cursor-default">{{COL_FIELD CUSTOM_FILTERS}}</div>';
        const selectCellTemplate =
            '<div class="ui-grid-cell-contents cursor-default text-center"><input type="checkbox" style="margin: 0; vertical-align: middle" ng-model="row.entity.myInvoiceEnabled" ng-disabled="!row.entity.principalMyInvoiceEnabled || !grid.appScope.$ctrl.canToggleMyInvoice() || !grid.appScope.$ctrl.invitedEntity.isSeller()" ng-click="grid.appScope.$ctrl.toggleMyInvoice(row.entity)">&nbsp;</div>';
        const resendInvitationCellTemplate =
            '<div><button class="btn btn-xs btn-primary btn-block" style="margin: 5px; width: 93%"  type="button" ng-click="grid.appScope.$ctrl.resendInvitation(rowRenderIndex)">Générer</button></div>';
        this.principalGridOptions = {
            columnDefs: [
                {
                    name: 'principalEid',
                    displayName: 'principal.list.id',
                    headerCellFilter: 'translate',
                    width: '150',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer cursor-default',
                },
                {
                    name: 'principalName',
                    displayName: 'principal.list.corporateName',
                    headerCellFilter: 'translate',
                    minWidth: '150',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer cursor-default',
                    sort: { direction: 'asc', priority: 0 },
                },
                {
                    name: 'getPrincipalTypeInvitation()',
                    displayName: 'kiss_invited_entity.edit.principals_type_invitation',
                    headerCellFilter: 'translate',
                    minWidth: '200',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer cursor-default',
                },
                {
                    name: 'getCountryLabelOfPrincipal()',
                    displayName: 'principal.list.country',
                    headerCellFilter: 'translate',
                    headerCellClass: 'text-center',
                    width: '120',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer cursor-default  text-center',
                },
                {
                    name: 'myInvoiceEnabled',
                    type: 'boolean',
                    displayName: 'kiss_invited_entity.edit.principals.myinvoice',
                    enableCellEdit: true,
                    headerCellClass: 'text-center',
                    width: '100',
                    headerCellFilter: 'translate',
                    cellTemplate: selectCellTemplate,
                    cellClass: 'pointer cursor-default',
                    enableSorting: false,
                },
                {
                    name: 'resendInvitation',
                    type: 'button',
                    displayName: 'Réémettre invitation',
                    headerCellClass: 'text-center',
                    width: '120',
                    headerCellFilter: 'translate',
                    cellTemplate: resendInvitationCellTemplate,
                    cellClass: 'pointer cursor-default',
                    enableSorting: false,
                },
                {
                    name: 'acceptation',
                    displayName: 'invited_entity_relation.list.acceptation',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'shortDate'",
                    cellClass: 'pointer cursor-default',
                },
            ],
            exporterOlderExcelCompatibility: false,
            useExternalPagination: false,
            useExternalSorting: false,
            onRegisterApi: gridApi => (this.principalGridApi = gridApi),
            enableSorting: true,
            enableGridMenu: false,
            enableRowSelection: false,
            enableColumnMenus: false,
            data: this.invitedEntityBo.principal.items,
        };

        if (!this.invitedEntity.isNotified()) {
            this.principalGridOptions.columnDefs[5].visible = false;
        }

        this.isEditAuthorizedSelRbtKey = this.invitedEntity.invoiceEmailShared &&
            this.invitedEntity.invoiceSenderEmail.length !== 0 && this.AuthSvc.isAuthorized('SUPPORT');
    }

    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    exportCsv() {
        this.usersGridOptions.exporterCsvFilename =
            'utilisateurs-compte-invite_' + moment().format('DDMMYYYY') + '.csv';
        this.usersGridOptions.exporterHeaderFilter = this.$translate.instant;
        this.userGridApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
    }

    /**
     * Activation / Désactivation de MyInvoice.
     */
    toggleMyInvoice(entity) {
        if (entity.myInvoiceEnabled) {
            this.KissSellerSvc.canEnableMyInvoice(this.invitedEntity.id, entity.principalId).then(
                report => {
                    if (report.status === 'SUCCESS') {
                        this.openMyInvoiceConfirmActivate(entity);
                    } else {
                        entity.myInvoiceEnabled = false;
                        this.openMyInvoiceErrorModal(entity, report);
                    }
                },
                error => {
                    this.logger.error('error.generic', error);
                    entity.myInvoiceEnabled = false;
                }
            );
        } else {
            this.KissSellerSvc.disableMyInvoice(this.invitedEntity.id, entity.principalId);
        }
    }

    // Popup affichée dans le cas où l'activation de MyInvoice n'est pas possible.
    openMyInvoiceErrorModal(entity, report) {
        this.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'principal.sellers.myInvoice.title.cantEnable' };
                    },
                    modalMessage: () => {
                        return [{ key: report.message }];
                    },
                    modalCancelButtonText: () => {
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return null;
                    },
                    data: () => {
                        return entity;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => {
                    return this.cancelEnableMyInvoice(entity);
                },
                () => {
                    return this.cancelEnableMyInvoice(entity);
                }
            );
    }

    // Popup affichée pour la confirmation de l'activation de MyInvoice.
    openMyInvoiceConfirmActivate(entity) {
        this.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'principal.sellers.myInvoice.title.enableConfirmation' };
                    },
                    modalMessage: () => {
                        return [
                            {
                                key: 'principal.sellers.myInvoice.enableMessage',
                                values: { principalName: entity.principalName },
                            },
                        ];
                    },
                    modalCancelButtonText: () => {
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return { value: 'commons.confirm' };
                    },
                    data: () => {
                        return entity;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => {
                    return this.confirmEnableMyInvoice(entity);
                },
                () => {
                    return this.cancelEnableMyInvoice(entity);
                }
            );
    }

    // Confirmation de l'activation de MyInvoice.
    confirmEnableMyInvoice(entity) {
        this.KissSellerSvc.enableMyInvoice(this.invitedEntity.id, entity.principalId);
    }

    // Annulation de l'activation de MyInvoice.
    cancelEnableMyInvoice(entity) {
        if (entity) {
            entity.myInvoiceEnabled = false;
        }
    }

    // Affiche la liste des sociétés etant en relation avec le fournisseur.
    viewRelations() {
        const principalInfo = {
            corporateName: null,
            eid: null,
        };
        if (this.principal && this.principal.detail) {
            principalInfo.corporateName = this.principal.detail.corporateName;
            principalInfo.eid = this.principal.detail.eid;
        }
        const idSearch =
            this.invitedEntity.isBuyer() && this.invitedEntity.biProfil
                ? this.invitedEntity.idBiProfil
                : this.invitedEntity.id;
        this.$state.go('app.invitedentity.sellerrelations', { id: idSearch });
    }

    // Affiche la liste des sociétés etant en relation avec le client invité .
    viewInBuyersRelations() {
        const idSearch =
            this.invitedEntity.isSeller() && this.invitedEntity.biProfil
                ? this.invitedEntity.idBiProfil
                : this.invitedEntity.id;
        this.$state.go('app.invitedentity.buyerrelations', { id: idSearch });
    }
    // Affiche Liste des demandes de connexion.
    viewConnexion() {
        this.$state.go('app.link_request.buyer', { legalEntityId: this.invitedEntity.legalEntity.id ,id:this.invitedEntity.id});
    }


    goBack() {
        this.$window.history.back();
    }
    /**
     * Supression du compte invité.
     */
    deleteInvitedEntity() {
        this.$uibModal
            .open({
                component: 'modalDeleteInvitedEntity',
                size: 'lg',
                resolve: {
                    invitedEntity: () => {
                        return this.invitedEntity;
                    },
                },
            })
            .result.then(
                () => {
                    this.goBack();
                },
                () => {}
            );
    }

    /**
     * Activation d'une entité invitée inactive.
     */
    activateInvitedEntity() {
        if (this.invitedEntity.isInactive()) {
            this.invitedEntitySvc.canActivateInvitedEntity(this.invitedEntity.id).then(
                activationCheckResult => {
                    if (!activationCheckResult.duplicateInvitedEntity) {
                        this.openCanActivateModal(activationCheckResult);
                    } else {
                        this.openCantActivateModal(activationCheckResult);
                    }
                },
                error => {
                    this.logger.error('error.generic', error);
                }
            );
        }
    }

    createNewUser() {
        const userBo = new this.UserBo();
        userBo.seller = this.invitedEntity;
        userBo.user.roles = ['EXECUTIVE'];
        this.KissUserSvc.setUserCreationData(userBo);
        this.$state.go('app.kissuser.new', {
            principalId: this.principalEntity.id,
            previousState: { name: this.$state.current.name, params: this.$state.params },
            legalEntityId: this.invitedEntity.legalEntity.id
        });
    }

    confirmSellerActivation() {
        this.invitedEntitySvc.activateInvitedEntity(this.invitedEntity.id).then(
            () => {
                this.logger.success('kiss_invited_entity.edit.activation_success');
                setTimeout(this.$window.location.reload(), 3500);
            },
            error => {
                this.logger.error('error.generic', error);
            }
        );
    }

    // Nous dit si l'entité invitée peut être reinvitée à nouveau. (Réactiver)
    canReactivateInvitedEntity() {
        return this.AuthSvc.isAuthorized('SUPPORT') && this.invitedEntity.isInactive();
    }

    // Nous dit si l'utilisateur a le droit d'activer myInvoice.
    canToggleMyInvoice() {
        return this.AuthSvc.isAuthorized('CONFIGURATOR');
    }

    // Popup affichée pour la confirmation de l'activation du fournisseur.
    openCanActivateModal(activationCheckResult) {
        this.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'kiss_invited_entity.edit.modal.can_activate_title' };
                    },
                    modalMessage: () => {
                        var messages = [];
                        messages.push({ key: 'kiss_invited_entity.edit.modal.can_activate_msg1' });
                        if (activationCheckResult.changeIdDto && activationCheckResult.changeIdDto.email) {
                            messages.push({
                                key: 'kiss_invited_entity.edit.modal.can_activate_msg2',
                                values: { email: activationCheckResult.changeIdDto.email },
                            });
                        }
                        messages.push({ key: 'kiss_invited_entity.edit.modal.can_activate_msg3' });
                        messages.push({ key: 'kiss_invited_entity.edit.modal.can_activate_msg4' });
                        return messages;
                    },
                    modalCancelButtonText: () => {
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return { value: 'commons.confirm' };
                    },
                    data: () => {
                        return activationCheckResult;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                () => {
                    this.confirmSellerActivation();
                },
                () => {}
            );
    }

    // Popup affichée dans le cas où l'activation du compte invité n'est pas possible pour cause de doublon.
    openCantActivateModal(activationCheckResult) {
        this.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'kiss_invited_entity.edit.modal.cant_activate_title' };
                    },
                    modalMessage: () => {
                        var messages = [];
                        messages.push({
                            key: 'kiss_invited_entity.edit.modal.cant_activate_msg1',
                            values: {
                                idFiscal: activationCheckResult.duplicateInvitedEntity.legalEntity.idFiscal,
                                idNational: activationCheckResult.duplicateInvitedEntity.legalEntity.idNational,
                            },
                        });
                        messages.push({ key: 'kiss_invited_entity.edit.modal.cant_activate_msg2' });
                        return messages;
                    },
                    modalCancelButtonText: () => {
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return null;
                    },
                    data: () => {
                        return activationCheckResult;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                function () {},
                function () {}
            );
    }

    isAuthorisedToDeleteInvitedEntity() {
        return this.AuthSvc.isEditAuthorized();
    }

    resendInvitation(rowIndex) {

        this.$uibModal
            .open({
                component: 'modalResendInvitation',
                size: 'lg',
                resolve: {
                    invitedEntity: () => {
                        return this.invitedEntity;
                    },
                    principalRelations: () => {
                        return this.principalInfos[rowIndex];
                    },

                    invitation: () => {
                        return this.invitations[rowIndex];
                    },
                    users: () => {
                        return this.users;
                    },
                },
            })
            .result.then(
                () => {
                    this.goBack();
                },
                () => {}
            );
    }
    // indique si le compte est client invité et a des demandes de connexion
    hasBuyerLinkRequest(){
        return (this.invitedBuyerLinkRequestCount > 0 ) ;
    }
    /** Permet de mettre à jour le code émetteur fournisseur en vérifiant que ce dernier a bien été modifié
     */
    save() {
        if (this.form.$valid) {
            this.updateSellerRobotKey();
        }
    }

    /** Permet de mettre à jour le code émetteur fournisseur
     */
    updateSellerRobotKey() {
        this.invitedEntitySvc.updateSellerRobotKey(this.invitedEntity.id, this.invitedEntity.sellerRobotKey).then(
            () => {
                this.logger.success('kiss_invited_entity.edit.update-robot-key-success');
            },
            error => {
                if (error.status === 400 && error.data) {
                    if (error.data.code === 'SELLER_ROBOT_KEY_ALREADY_EXISTS') {
                        this.logger.error('error.functional.seller_robot_key_already_exists');
                    }
                } else {
                    this.logger.error('error.generic', error);
                }
            }
        );
    }
}

angular.module('app.invitedentity').component('editInvitedEntity', {
    templateUrl: require('./edit-invited-entity.html'),
    controller: editInvitedEntityCtrl,
    bindings: {
        invitedEntityBo: '<',
    },
});
